module.exports = __webpack_public_path__ + "static/ARB_Logo-usage_correct4-5bf6c9bd46f75a5e668403715e98b79e.jpg";